import Vue from 'vue'
import Router from 'vue-router'



import MainPage from '@/components/MainPage.vue'
import AU from '@/components/AboutUs.vue'
import News from '@/components/News.vue'
import NewsPage from '@/components/NewsPage.vue'
import Privacy from '@/components/Privacy.vue'
import Service from '@/components/Service.vue'
import Contact from '@/components/Contact.vue'
import Products from '@/components/Products.vue'
import QualityInsure from '@/components/QualityInsure.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [

    // { path: '/', redirect: { name: 'mainpage' }}

    {
      path: '/',
      name: 'mainpage',
      component: MainPage,
      meta: {
        title: '首頁-久億光電-LED字幕機/廣告招牌/跑馬燈/電視牆/電子看板/顯示屏/亮化工程/燈具'
      }
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: AU,
      meta: {
        title: '關於我們-久億光電'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      meta: {
        title: '最新消息-久億光電'
      }
    },
    {
      path: '/charttest',
      name: 'charttest',
      component: Products,
      meta: {
        title: '產品型錄-久億光電'
      }
    },
    {
      path: '/charttest?tag=:tag&page=:page',
      name: 'charttest_tag',
      component: Products,
      meta: {
        title: '產品型錄-久億光電'
      }
    },
    {
      path: '/newspage/:placeName',
      name: 'newspage',
      component: NewsPage,
      meta: {
        title: '新聞-久億光電'
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
      meta: {
        title: '隱私權政策-久億光電'
      }
    },
    {
      path: '/service',
      name: 'service',
      component: Service,
      meta: {
        title: '服務條款-久億光電'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: {
        title: '聯絡我們-久億光電'
      }
    },
    {
      path: '/QI',
      name: 'qualityinsure',
      component: QualityInsure,
      meta: {
        title: '品質認證-久億光電'
      }
    },


  ],
  linkActiveClass: 'myActive',
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return {
      x: 0,
      y: 0
    }
  }

})



// WEBPACK FOOTER //
// ./src/router/index.js